import React from "react";
import ComingSoon from "../../components/comingsoon/comingsoon.js";
//import Partner from "../../components/partner/partner.js";
import CTA from "../../components/cta/cta.js";
import Intro from "../../components/Intro/intro.js";
import Events from "../../components/events/events.js";

function HomePage() {
  return (
    <div>
      <Intro />
      <Events />
      {/* <Partner /> */}
      <CTA />
      <ComingSoon />
    </div>
  );
}

export default HomePage;
